import {Component, Optional, SkipSelf} from '@angular/core';

import {QlService} from "../../../../../../../core/shared/ql/service/ql.service";
import {BmContractPaymentPlannedComponent} from "../../bm-contract-payment-planned.component";
import * as testDataA from "../data/mock-testA.json"
import {createQlTestFactory} from "../../../../../../../core/shared/ql/mock/ql-test-factory";

@Component({
    selector: 'bm-contract-payment-planned-test',
    templateUrl: '../../bm-contract-payment-planned.component.html',

    standalone: false,
    providers: [
        {
            provide: QlService,
            useFactory: createQlTestFactory(testDataA),
            deps: [[new SkipSelf(), new Optional(), QlService]]
        }
    ]
})
export class BmContractPaymentPlannedTestComponent
    extends BmContractPaymentPlannedComponent {

}